import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  { label: 'Giới thiệu', to: '/about' },
  { label: 'Trang chủ', to: '/' },
  { label: 'Túi Trò Chơi', to: '/games' },
  { label: 'Hạt Giống Tri Thức', to: '/knowledge' },
  { label: 'Cộng đồng', to: '/community' },
];

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-white/95 backdrop-blur-sm'}`}>
      <div className="px-6 py-3 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2 cursor-pointer flex-shrink-0">
          <img
            src="https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/9074dcc9d7143784ab7725571df8118f.jpeg"
            alt="Logo"
            className="w-10 h-10 object-contain rounded-xl"
          />
          <span className="text-base font-bold text-primary-brown-dark whitespace-nowrap leading-tight">
            TÚI TRÒ CHƠI<br /><span className="text-primary-orange">DÂN GIAN BAHNAR</span>
          </span>
        </Link>

        {/* Nav */}
        <nav className="hidden lg:flex items-center gap-1">
          {NAV_ITEMS.map(item => (
            <Link
              key={item.to}
              to={item.to}
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
                location.pathname === item.to
                  ? 'bg-primary-orange/10 text-primary-orange'
                  : 'text-primary-brown-light hover:text-primary-orange hover:bg-primary-orange/5'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>


      </div>
    </header>
  );
}
